import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class InvalidTokenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidTokenError";
    }
}
export class InvalidOtpError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidOtpError";
    }
}
export class MfaFactorNotAllowedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "MfaFactorNotAllowedError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    InvalidTokenError,
    InvalidOtpError,
    MfaFactorNotAllowedError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
